import { type FC } from "react";
import { AppBar, Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Вкладки карточки продукта. До фазы 4 их не было вовсе, поэтому
// компонент монтируется только на платформах с включённым комплаенсом
// (см. EditProductDialog), а без него карточка выглядит ровно как раньше.
export const ProductTabsMenu: FC<{ tab: string }> = ({ tab }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const items = [
    { name: "edit", label: t("products.tabs.edit") },
    { name: "records2257", label: t("compliance.tab") },
  ];

  const value = items.some((item) => item.name === tab) ? tab : false;

  return (
    <AppBar position="static" color="default" elevation={0}>
      <Tabs value={value} scrollButtons="auto" variant="scrollable">
        {items.map(({ name, label }) => (
          <Tab
            key={name}
            value={name}
            label={label}
            onClick={() => {
              searchParams.set("tab", name);
              setSearchParams(searchParams);
            }}
          />
        ))}
      </Tabs>
    </AppBar>
  );
};
